import { SignedIn } from "../auth/SignedIn";
import HeaderWithInstagram from "./HeaderWithInstagram";
import LoggedInHeader from "./LoggedInHeader";

const DynamicHeader = () => {
  return (
    <SignedIn fallback={<HeaderWithInstagram />}>
      <LoggedInHeader />
    </SignedIn>
  );
};

export default DynamicHeader;
